import { ClientReceipt } from "@dune/types";
import { Badge } from "@dune/ui";
import {
	formatCurrency,
	formatSimpleDate,
	getProductTypeLabel,
	getTypeLabel,
} from "@dune/utils";
import { ColumnDef } from "@tanstack/react-table";
import { ReceiptStatusBadge } from "../../../receipt/ReceiptStatusBadge";

export const clientReceiptsColumns = (): ColumnDef<ClientReceipt>[] => [
	{
		accessorKey: "reference",
		header: "Ref",
		cell: ({ row }) => (
			<div className="font-medium">{row.original.reference}</div>
		),
	},
	{
		accessorKey: "type",
		header: "Type",
		cell: ({ row }) => (
			<Badge variant="default">{getTypeLabel(row.original.type)}</Badge>
		),
	},
	{
		accessorKey: "issueDate",
		header: "Date d'émission",
		cell: ({ row }) => {
			const date = new Date(row.original.issueDate);
			return <div className="text-sm">{formatSimpleDate(date)}</div>;
		},
	},
	{
		accessorKey: "productType",
		header: "Produit",
		cell: ({ row }) => (
			<div className="text-sm">
				{getProductTypeLabel(row.original.productType)}
			</div>
		),
	},
	{
		accessorKey: "duneManagementFeesTTC",
		header: "Frais Dune TTC",
		cell: ({ row }) => {
			const amount = row.original.duneManagementFeesTTC;
			return (
				<div className="text-sm">{amount ? formatCurrency(amount) : "-"}</div>
			);
		},
	},
	{
		accessorKey: "brokerCommission",
		header: "Commission courtier",
		cell: ({ row }) => {
			const amount = row.original.brokerCommission;
			return (
				<div className="text-sm">
					{amount !== null && amount !== undefined
						? formatCurrency(amount)
						: "-"}
				</div>
			);
		},
	},
	{
		accessorKey: "status",
		header: "Statut",
		cell: ({ row }) => {
			const status = row.original.status;
			return <ReceiptStatusBadge status={status} />;
		},
	},
	{
		accessorKey: "proposition.constructionSite.address",
		header: "Adresse du chantier",
		cell: ({ row }) => {
			const address = row.original.proposition.constructionSite.address;
			return (
				<div className="text-sm text-gray-600">
					{address || "Non renseignée"}
				</div>
			);
		},
	},
];
